import React, { useEffect, useState } from "react";
import apiService from "../APIService";
import Tooltip from "@mui/material/Tooltip";

const UploadImage = (props) => {
  const [selected, setSelected] = useState("Choose File");
  const [showError, setShowError] = useState(false);
  const [sizeError, setSizeError] = useState();
  const [fileName, setFileName] = useState();
  const [path, setPath] = useState();
  const data = props.item && props.item.data && JSON.parse(props.item.data);
  const type = data?.extensions;
  const maxSize = 512 * 1024; // 512 KB
  const serror = data?.sizeError;

  const [selectedFile, setSelectedFile] = useState(false);
  const [isShowInputField, setIsShowInputField] = useState(false);
  const [restrictedFilesError, setRestrictedFilesError] = useState("");
  const [isRestrictedFilesError, setIsRestrictedFilesError] = useState(false);
  const [preview, setPreview] = useState("");

  let name;

  const handleChange = (e) => {
    const files1 = e.target.value.split("\\");
    name = files1[files1.length - 1];

    const file = e?.target?.files && e?.target?.files[0];

    if (file) {
      // Check file format
      const fileExtension = name?.split(".").pop().toLowerCase();
      if (!type?.some((el) => el.includes(fileExtension))) {
        setFileName(name);
        setPreview(URL?.createObjectURL(file));
        setRestrictedFilesError("Invalid file type. Please upload a PNG, JPG, or JPEG image.");
        setIsRestrictedFilesError(true);
        setSelected(name);
        return;
      }

      // Check file size (512 KB limit)
      if (file?.size > maxSize) {
        setFileName(name);
        setPreview(URL?.createObjectURL(file));
        setSizeError("File size should not be greater than 512 KB");
        setShowError(true);
        setSelected(name);
        setRestrictedFilesError(""); // Clear restricted files error
        return;
      }

      // If the file is valid, update state
      setPath(file);
      setFileName(name);
      setPreview(URL?.createObjectURL(file));
      setSelected(name);

      // Reset errors
      setShowError(false);
      setIsRestrictedFilesError(false);
      setRestrictedFilesError("");
      setSelectedFile(true);
    } else {
      setShowError(false);
      setSelectedFile(false);
      setRestrictedFilesError("");
    }
  };

  useEffect(() => {
    setFileName(name);
  }, [props.name]);

  const handleUpload = () => {
    console.log("uploadData", path);
    apiService.uploadMedia(path).then((response) => {
      let data = { key1: response.data.key1 };
      props.handleClick(props.item.code, data);
      props.setTextOnClick(preview);
      console.log("uploadresponse", response);
      setIsShowInputField(true);
      setSelectedFile(false);
    });
  };

  const style = {
    cursor: !selectedFile ? "not-allowed" : "pointer",
  };

  return (
    <>
      <p
        className="bold"
        style={{ color: "#444444", fontSize: "14px", margin: "0px" }}
      >
        Upload File
      </p>
      <div
        className={isShowInputField ? "disabled-custom-file" : "custom-file"}
      >
        <input
          type="file"
          className="custom-file-input"
          id="customFile"
          accept="image/jpeg, image/png, image/jpg"  // Restrict file types
          onChange={handleChange}
          disabled={isShowInputField}
        />
        <label className="custom-file-label" for="customFile">
          {selected}
        </label>
      </div>

      <div className="form-group" style={{ marginTop: "8px" }}>
        {showError && (
          <p style={{ color: "red", fontSize: "14px" }}>{sizeError}</p>
        )}
        {isRestrictedFilesError && (
          <p style={{ color: "red", fontSize: "14px" }}>
            {restrictedFilesError}
          </p>
        )}
        <div className="btn-contr text-left">
          <Tooltip
            title={
              <span style={{ fontSize: "14px" }}>Please upload some files</span>
            }
            placement="right-start"
          >
            <a
              className={!selectedFile ? "disabled-submit-btn" : "submit-btn"}
              href="#!"
              style={{ fontSize: "15px" }}
              onClick={() => {
                handleUpload();
                props.setTextOnClick(props.item.text);
              }}
              disabled={!selectedFile}
              
            >
              Upload
            </a>
          </Tooltip>
        </div>
        <div className="height50">&nbsp;</div>
      </div>
    </>
  );
};

export default UploadImage;
